// ── Logical space (scaled to viewport each frame, DPR ≤ 2) ──
export const W = 480;
export const H = 600;

export const COLS = 7;
export const ROWS = 6;
export const CELL = 60;          // logical px per cell

export const BOARD_W = COLS * CELL;   // 420
export const BOARD_H = ROWS * CELL;   // 360
export const BOARD_X = 30;            // left edge of board
export const BOARD_Y = 160;           // top edge of board (HUD 0..80, preview 80..160)
export const DISC_R = 24;             // disc radius (diameter 48, 6px gap to 60 cell)
export const PREVIEW_Y = 120;         // y-center of the floating preview disc

export const AI_DEPTH = 5;            // minimax search depth
export const THINK_DELAY = 500;       // ms the bot "thinks" before dropping

export const STATS_KEY = 'game-connect4-stats';

// Board cell values — numeric for fast AI search. row 0 = bottom.
export type Cell = 0 | 1 | 2;
export const EMPTY: Cell = 0;
export const HUMAN: Cell = 1;
export const BOT: Cell = 2;

export type Player = 'human' | 'bot';
export type Phase = 'menu' | 'playing' | 'won' | 'draw';

export const idx = (col: number, row: number): number => row * COLS + col;

export interface Stats { wins: number; losses: number; draws: number; }

export interface GameState {
  board: Cell[];            // length COLS*ROWS, index = row*COLS+col, row 0 bottom
  currentPlayer: Player;
  phase: Phase;
  moves: number;            // occupied cells (draw at COLS*ROWS)
  winner: Player | null;    // set when phase === 'won'
  winLine: number[] | null; // board indices of the winning run (for the glow)
  stats: Stats;
}

export interface Button { x: number; y: number; w: number; h: number; }

export interface Theme {
  bg: string;
  board: string;
  holeEmpty: string;
  holeShadow: string;
  accent: string;
  accentDim: string;
  winGlow: string;
  text: string;
  textDim: string;
  overlayBg: string;
  btnBg: string;
  btnText: string;
  red: string; redDark: string;
  yellow: string; yellowDark: string;
}

// ── Transient visual state (lives outside GameState) ──
export interface Falling {
  col: number;
  row: number;
  player: Player;
  y: number;      // current interpolated y (updated each frame)
}

export interface View {
  now: number;
  previewCol: number | null;  // highlighted column + floating preview + landing ghost
  falling: Falling | null;
  botThinking: boolean;
  shakeMs: number;            // ms since shake start (Infinity = no shake)
}
